import {
  ArrowDownCircleIcon,
  BuildingOfficeIcon,
} from "@heroicons/react/24/solid";
import React, { useRef, useState } from "react";
import MaterialTableTS from "../../../../components/tables/MaterialTableTS";
import useGetAllOpenOffices from "./hooks/useGetAllOpenOffices";
import { CSVLink } from "react-csv";
import { toast } from "../../../../components/toastNotification";
import DownloadButton from "../../../../components/DownloadButton";
import { CarrierAgreementMgmtTabs } from "../../carrierAgreementTabs";
import { useRecoilState, useRecoilValue } from "recoil";
import { mainSelectedTab } from "../../atoms";
import { useHistory } from "react-router-dom";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { officeShowState } from "../../OfficeSettings/atoms/atoms";
import { OfficeTabs } from "../../../OfficeTab/OfficeTabs";
import { ReportsTabs } from "../../../ReportsTab/ReportsTab";
import { accountAtom } from "../../../Login/atoms/AccountAtom";

interface IAllOpenOffice {
  storeNumber: string;
  officeCode: string;
  officeType: string;
  salesTypeC: string;
  channelC: string;
  officeName: string;
  address: string;
  city: string;
  state: string;
  zipCode: number;
  officeStatus: string;
  phone: number;
  brand: string;
  entityName: string;
  officeOpenedDate: string;
  brandMarketingName: string;
}

interface AllOpenOfficesProps {}
export const AllOpenOffices: React.FC<AllOpenOfficesProps> = () => {
  const [exportData, setExportData] = useState([]);
  const { data: allOpenOffice, isLoading: allOfficeLoading } =
    useGetAllOpenOffices();
  const tableRef = useRef<any>([]);
  const [, setSelectedIndex] = useRecoilState(mainSelectedTab);
  const history = useHistory();
  const userPermissions = useRecoilValue(permissionsSelector);
  const [isShow, setShowState] = useRecoilState(officeShowState);
  const user = useRecoilValue(accountAtom);

  function formatDate(date) {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;
    return [month, day, year].join("/");
  }

  //For downloading table data
  const mapDataToExport = (data) => {
    setExportData(
      data?.map((ofc: IAllOpenOffice) => {
        return {
          "Corporate Office #": ofc.storeNumber,
          "Office Code": ofc.officeCode,
          Type: ofc.officeType,
          SalesType: ofc.salesTypeC,
          Channel: ofc.channelC,
          "Office Name": ofc.officeName,
          Street: ofc.address,
          City: ofc.city,
          State: ofc.state,
          "Zip Code": ofc.zipCode,
          "Office Status": ofc.officeStatus,
          Phone: ofc.phone,
          Brand: ofc.brandMarketingName,
          "Legal Entity": ofc.entityName,
          "Office Opened Date": ofc.officeOpenedDate
            ? formatDate(ofc.officeOpenedDate)
            : "",
        };
      })
    );
  };
  let dateTimeToday = new Date(new Date().toLocaleString()).toLocaleString();
  const csvReport = {
    filename: "AllOpenOfficesReports_" + dateTimeToday + ".csv",
    data: exportData,
  };
  //
  //console.log("dateTimeToday", dateTimeToday);
  const officeColumns = [
    { title: "Corporate Office #", field: "storeNumber" },
    { title: "Office Code", field: "officeCode" },
    { title: "Type", field: "officeType" },
    { title: "SalesType", field: "salesTypeC" },
    { title: "Channel", field: "channelC" },
    {
      title: "Office Name",
      field: "officeName",
      render: (rowData) => {
        return (
          <div
            className="cursor-pointer"
            onClick={() => {
              const url = "/reportstab/office/allopen_offices_reports";
              history.push({
                pathname: "/officesettings/officesetting",
                state: {
                  officeCode: rowData?.officeCode,
                  action: "AllOpenOfficeReports",
                },
              });
              window.location.reload();
              let userTabs = [
                {
                  to: "",
                },
              ];
              [...ReportsTabs].forEach((tabs) => {
                let temp = [...userPermissions].filter(
                  (user) => user === tabs.permission
                );
                if (temp.length > 0)
                  userTabs.push({
                    to: tabs.to,
                  });
              });
              userTabs.shift();
              const index = userTabs.findIndex((c) => c.to === url);
              setSelectedIndex(index);
            }}
          >
            <span className="text-quinary  font-bold underline text-sm ">
              {rowData.officeName}
            </span>
          </div>
        );
      },
    },
    { title: "Street", field: "address" },
    { title: "City", field: "city" },
    { title: "State", field: "state" },
    { title: "Zip Code", field: "zipCode" },
    { title: "Office Status", field: "officeStatus" },
    { title: "Phone", field: "phone" },
    { title: "Brand", field: "brandMarketingName" },
    { title: "Legal Entity", field: "entityName" },
    {
      title: "Office Opened Date",
      field: "officeOpenedDate",
      typeof: "date",
      dateSetting: { locale: "en-US", format: "MM/dd/yyyy" },
      render: (rowData) => {
        return (
          <div>
            {rowData.officeOpenedDate
              ? formatDate(rowData.officeOpenedDate)
              : ""}
          </div>
        );
      },
    },
  ];

  return (
    <div className="text-xs items-center">
      <div className="">
        <div className="mx-4 mt-4 overflow-x-auto">
          <div className="flex mb-2 gap-2 items-center">
            <div>
              <BuildingOfficeIcon className="text-white bg-blue-500 rounded-md h-7 w-7 p-1" />
            </div>
            <div className="flex flex-col leading tight">
              <div className="text-gray-500 text-md font-medium">
                Report: Accounts
              </div>
              <div className="flex items-center font-bold text-lg text-primary">
                OPEN OFFICES: ALL
              </div>
            </div>
          </div>
          {/* <div className="text-xs font-normal mt-1">
            {" "}
            All Office Types with Status Open
          </div> */}
          <div className="mt-2" />
          <div className="flex justify-between mb-2 mr-2">
            <div className="flex items-center gap-1">
              <span className="text-gray-500 text-sm">Total Records: </span>
              <span className="text-primary text-base font-semibold">
                {
                  allOpenOffice?.filter((x) =>
                    user?.isFranchise && user?.isNonFranchise
                      ? true
                      : user?.isFranchise
                      ? x.officeType?.toLowerCase() === "franchise"
                      : x.officeType?.toLowerCase() !== "franchise"
                  ).length
                }
              </span>
            </div>
            <CSVLink className="" {...csvReport}>
              <DownloadButton
                buttonValue="Download File"
                onClick={() =>
                  mapDataToExport(tableRef.current.dataManager.searchedData)
                }
                className={undefined}
                disabled={undefined}
              />
            </CSVLink>
          </div>
        </div>
        <div className="box-shadow mx-4 mb-4 mt-2 overflow-x-auto grid grid-row">
          <MaterialTableTS
            data={allOpenOffice?.filter((x) =>
              user?.isFranchise && user?.isNonFranchise
                ? true
                : user?.isFranchise
                ? x.officeType?.toLowerCase() === "franchise"
                : x.officeType?.toLowerCase() !== "franchise"
            )}
            isLoading={allOfficeLoading}
            columns={officeColumns}
            showTitle={false}
            showToolbar={true}
            toolbarSearch={true}
            searchFieldAlignment="left"
            tableRef={tableRef}
          />
        </div>
      </div>
    </div>
  );
};
